export default {
    RECEIVE_OUTINGS_OF_HARBOUR: 'RECEIVE_OUTINGS_OF_HARBOUR',
    RECEIVE_OUTING_OF_HARBOUR: 'RECEIVE_OUTING_OF_HARBOUR',
    DELETE_OUTING_OF_HARBOUR: 'DELETE_OUTING_OF_HARBOUR',
};
